<template>
    <div>
        <v-server-table ref="jobsiteInsuranceTbl" :url="`/jobsites/insurance/${jobsiteId}`" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <router-link :to="`/jobsites/insurance/${jobsiteId}/edit`" class="btn btn-light ml-2">
                    <i class="fa fa-plus-circle"></i> Add Insurance
                </router-link>

                <button type="button" class="btn btn-success ml-2" @click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="id" slot-scope="props">
                <router-link :to="`/jobsites/insurance/${jobsiteId}/edit/${props.row.id}`" title="Edit Insurance" class="btn btn-sm btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
            </template>

            <template slot="coverage_amount" slot-scope="props">
                {{ props.row.coverage_amount | currency }}
            </template>

            <template slot="start_date" slot-scope="props">
                {{ props.row.start_date | moment("MM/DD/YYYY") }}
            </template>

            <template slot="expire_date" slot-scope="props">
                {{ props.row.expire_date | moment("MM/DD/YYYY") }}
            </template>

            <template slot="policy_file_id" slot-scope="props">
                <a :href="`/files/download/${props.row.policy_file_id}`" v-if="props.row.policy_file_id">
                    {{ props.row.file_name }}
                </a>
            </template>

            <!-- <template slot="child_row" slot-scope="props">
                <div class="form-group">
                    <label class="text-muted">Meeting Notes:</label>
                    <div v-html="props.row.meeting_notes"></div>
                </div>
            </template> -->

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: {
            jobsiteId: {
                required: true,
            },
        },

        data: function() {
            return {
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                tableName: 'jobsiteInsuranceTbl',

                columns: [
                    'id',
                    'coverage_type',
                    'policy_nbr',
                    'coverage_amount',
                    'start_date',
                    'expire_date',
                    'policy_file_id',
                ],

                options: {
                    headings: {
                        id: 'Actions',
                        coverage_type: 'Coverage Type',
                        policy_nbr: 'Policy#',
                        coverage_amount: '$ Amount',
                        start_date: 'Start Date',
                        expire_date: 'Expiration Date',
                        policy_file_id: 'Policy',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'jobsite_insurance.start_date',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('JobsiteInsuranceListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'safety_meeting_id',
                },
            }
        },

        methods: {

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    query: (this.$refs.jobsiteInsuranceTbl.getRequestParams()).query,
                    orderBy: this.$refs.jobsiteInsuranceTbl.options.orderBy.column,
                    ascending: this.$refs.jobsiteInsuranceTbl.options.orderBy.ascending,
                    table: 'jobsiteInsuranceTbl',
                    columns: this.$refs.jobsiteInsuranceTbl.columns,
                };

                //Send it
                this.$http.get('/jobsites/insurance/'+this.jobsiteId+'?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Jobsite Insurance');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            goTo(url){
                //Push
                this.$router.push(url);
            },
        },

        mounted(){

        }
    }
</script>
